export default "__VITE_ASSET__62RTkKmb__"